export class Direccion {
    calle=""
    nro=0
    lat=0
    long=0
    dpto=""
    piso=""
    lote=""
    mza=""
    pais=""
    nota=""
    barrio=""
    localidad="Córdoba, Córdoba"
}
